<template>

    <div class="login-area">
        <transition name="slide-fade" mode="out-in">
      
            <router-view></router-view>
                                
        </transition>
    </div>
  
</template>

<script>
export default {

}
</script>

<style>

</style>